import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import CompanyLinksEditModal from 'modules/dashboard/widgets/CompanyLinks/components/Modal/CompanyLinksEditModal'

export const CompanyLinksEditActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return <CompanyLinksEditModal handleClose={closeActivity} handleCancel={closeActivity} />
}
